/**
 * @file src/dashboard.i18n.js
 * Chuỗi của bảng nạp bài. Để riêng một chỗ cho gọn, và để sau này dịch được — trang này
 * là công cụ nội bộ nên hiện chỉ có tiếng Việt.
 */
const BẢNG = /** @type {Record<string, string>} */ ({
  title: 'Dựng bài từ model',
  lead: 'Ném file .glb, file chữ .json và ảnh poster vào đây. Số bước luôn lấy theo model; bước nào file chữ chưa có thì vẫn hiện đủ, chỉ là chưa có tên.',
  'dz.glb': 'Model 3D',
  'dz.glb.hint': 'Kéo file .glb vào đây, hoặc bấm để chọn. Bắt buộc.',
  'dz.json': 'File chữ',
  'dz.json.hint': 'lesson.content.json hoặc bản gộp lesson.json. Không có cũng dựng được.',
  'dz.poster': 'Ảnh poster',
  'dz.poster.hint':
    'Ảnh nền màn hình tải, và ảnh dự phòng khi máy không chạy được 3D. Không có cũng dựng được.',
  'sum.poster': 'Poster: {ten}',
  download: 'Tải lesson.json (bản gộp)',
  go: 'Dựng bài',
  drawer: 'Bảng nạp',
  working: 'Đang dựng…',
  noname: '(chưa có tên)',
  'col.scene': 'Bước',
  'col.name': 'Tên bước',
  'col.notes': 'Chú thích',
  'col.filled': 'Ô chữ đã điền',
  'col.anim': 'Animation',
  sum: 'Model có {model} bước · file chữ phủ {json} bước.',
  'warn.missing':
    '{n} bước file chữ không nhắc tới ({ids}). Vẫn hiện đủ trong bài — đúng góc nhìn, đúng lớp cắt — nhưng để trống tên và chú thích, kể cả khi model có sẵn chữ nháp.',
  'warn.model':
    '{n} chỗ bên model khai chưa đúng quy ước. Bài vẫn dựng được, nhưng những chỗ này sẽ sai hoặc rơi mất chữ:',
  err: 'Không dựng được:',
  'err.noscene':
    'Model không có node nào tên scene1, scene2… nên không dựng được bước nào. Xem quy ước đặt tên trong MODEL-VA-FILE-TEXT.md.',
});

/**
 * Tra chuỗi. Trả về chính khoá nếu thiếu — thiếu chuỗi thì lộ ra ngay trên giao diện chứ
 * không im lặng thành ô trống.
 * @param {string} k @returns {string}
 */
export function T(k) {
  return BẢNG[k] ?? k;
}
